import { toast } from "react-toastify";
import api from "../api";
import i18next from "i18next";

const handleErrors = async (error) => {
  const { response } = error || {};
  const { status } = response || {};

  if (status === 401) {
    toast.error("Vaša sesija je istekla", { theme: "colored" });
    window.location.href = "/";
    localStorage.removeItem("token_value");
    localStorage.removeItem("loggedUser");
  } else {
    if (error.response.data instanceof Blob) {
      error.response.data = JSON.parse(await error.response.data.text());
    }
    throw error;
  }
};

const apiService = {
  get(url) {
    return api
      .get(url, {
        headers: getSimpleHeaders(),
      })
      .catch(handleErrors);
  },
  post(url, body) {
    return api
      .post(url, body, {
        headers: getSimpleHeaders(),
      })
      .catch(handleErrors);
  },
  getMultipart(url, body) {
    return api
      .get(url, body, {
        headers: getSimpleHeadersFile(),
      })
      .catch(handleErrors);
  },
  postMultipart(url, body) {
    return api
      .post(url, body, {
        headers: getSimpleHeadersFile(),
      })
      .catch(handleErrors);
  },
  putMultipart(url, body) {
    return api
      .put(url, body, {
        headers: getSimpleHeadersFile(),
      })
      .catch(handleErrors);
  },
  patch(url, body) {
    return api.patch(url, body, {
      headers: getSimpleHeaders(),
    });
  },
  put(url, body) {
    return api
      .put(url, body, {
        headers: getSimpleHeaders(),
      })
      .catch(handleErrors);
  },
  delete(url) {
    return api
      .delete(url, {
        headers: getSimpleHeaders(),
      })
      .catch(handleErrors);
  },

  getFromFile(url) {
    return api
      .get(url, {
        responseType: "blob",
        headers: getSimpleHeaders(),
      })
      .catch(handleErrors);
  },
};

function getSimpleHeaders() {
  const token = localStorage.getItem("token_value");
  return {
    "Content-Type": "application/json",
    "Accept-Language": i18next.language,
    Authorization: `${token}`,
  };
}

function getSimpleHeadersFile() {
  const token = localStorage.getItem("token_value");
  return {
    "Content-Type": "multipart/form-data",
    "Accept-Language": i18next.language,
    Authorization: `${token}`,
  };
}

export default apiService;
